import {Box} from '@mui/material';
import {styled} from '@mui/material/styles';

export const StyledBasketAppHeader = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
}));
